import React, { Component } from 'react';
import store from '../store';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

import Grid from '@material-ui/core/Grid';



import Divider from '@material-ui/core/Divider';

import { Link } from 'react-router-dom';

import BackIcon from '@material-ui/icons/ChevronLeft';
import { Redirect } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import firebase from "firebase/app";
import "firebase/firestore";
import _ from 'lodash'
import LessonComp from "../components/LessonComp"
import ButtonBase from '@material-ui/core/ButtonBase';
import * as STATIC from '../config/static';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';
import TopBar from '../components/TopBar';

const defaultSetting = {
  type: [],
  rows: 3,
  showTime: 6,
  answerTime: 6,
  qCount: 10,
  maxNumber: 10,
  digits: 1,
  digits1: 1,
  digits2: 1,
  displaySetting: 0,
  displayShow: 0,
  lessThan0: 0,
  isReversed:0
}


function searchLabel(array, value) {
  let rel = '';
  let index = array.findIndex(a => a.value == value);
  if (index > -1) {
    rel = array[index].label;
  }
  return rel;
}
let _this;
const DWIDTH = 980;

class Advance extends Component {
  constructor() {
    super();
    _this = this;
    this.state = { wWidth: 0, wHeight: 0, message: '', showResult: false,showResultDetail:false, showDetail:0,showDetail2:0, course: null,result:{},showChart:false,saving:false,saving_error:false };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = name => event => {

    event.preventDefault();
    this.setState({
      [name]: event.target.value

    });
  }

  async componentDidMount() {

    let checked = await STATIC.checkVersion();
    if(checked!=true)
    {
      //console.log(checked);
      store.dispatch({ type: 'UP_VER', UP_VER: checked });
    }
    if(this.props.g_practice)
    {
      let formular = _.sample(this.props.questions);
    //  console.log(formular);
      _this.setState({showAdvance:true,formular,title:'Practice'});
    }
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);


  // this.setState({  loading: false });

  }



  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }

  // async postResultToServer(result){
  //   console.log("post result");
  //   let LASTDAY = store.getState().LASTDAY;
  //   let day = result.day+1;
  //   let week = result.week;
  //   console.log(week,day);
  //   if(result.passPercent<=result.percent)
  //   {
  //
  //     if(day>=6)
  //     {
  //       week+=1;
  //       day = 1;
  //
  //     }
  //     else {
  //       day +=1;
  //     }
  //
  //     console.log(week,day);
  //     LASTDAY = {week,day};
  //
  //   }
  //   //console.log(JSON.stringify(result));
  //   //return;
  //   let res = await STATIC.postFormData(STATIC.API_STUDENT_POSTRESULT,{result:JSON.stringify(result),lweek:week,lday:day});
  //   console.log(res);
  //   if(res && res.status==1)
  //   {
  //     store.dispatch({ type: 'LASTDAY', LASTDAY });
  //   }
  // }
  onAdvanceEnd(questions) {
    //console.log(questions);
    let count = 0;
    let countCorrect = 0;
    for (let q of questions) {
      if (q.status) {
        count++;
        if (q.status == 1) {
          countCorrect++;
        }
      }
    }

    // if(count==countCorrect&&count==questions.length)
    // {
    //   _this.setState({showSignUp:true});
    // }

    let percent = Math.round(countCorrect / questions.length * 100);
    let ACCOUNT = store.getState().ACCOUNT;
    let nResult = {questions,percent,countCorrect,qlength: questions.length,group:questions.group?questions.group:''};
    if(ACCOUNT.type==0)
    nResult.id_student=ACCOUNT.id;
    if(ACCOUNT.type==1)
    nResult.id_teacher=ACCOUNT.id;
    //console.log(new Date().getTime());
    let key = JSON.stringify({id:ACCOUNT.id,time:(new Date().getTime())});
    nResult.key = STATIC.encryptStringWithRsaPublicKey(key);
      _this.postResultToServer(nResult);
    _this.setState({ showResultDetail: true,result:{percent,group:questions.group?questions.group:'',countCorrect,qlength: questions.length,questions},nResult });
  }
  async postResultToServer(result){
    if(!result)
    {
      _this.setState({saving:false,saving_error:false});
      return;
    }
   await  _this.setState({saving:true,saving_error:false});
    //let res = await STATIC.postFormData(STATIC.API_STUDENT_POSTRESULTADVANCE,{result:JSON.stringify(result)});
let res = await STATIC.postFormData(STATIC.API_STUDENT_POSTRESULTADVANCE,{result:JSON.stringify(result)});
if(res)
{
  if(res.status==0)
  {
    if(res.message=='Key not correct')
    {
      await  _this.setState({saving:false});
    }
    else {
      await  _this.setState({saving_error:true});
      let docid = "A"+(new Date().getTime());
      firebase.firestore().collection("results_error").doc(docid).set({...result,type:'advance',created:(new Date().getTime())});
    }
  }
  else {
    await  _this.setState({saving:false});
  }
}
else {
  await  _this.setState({saving_error:true});
  let docid = "A"+(new Date().getTime());
  firebase.firestore().collection("results_error").doc(docid).set({...result,type:'advance',created:(new Date().getTime())});
}
  }


  backClick() {
    if(_this.props.g_practice)
    {
    _this.props.history.push("/");
  } else
    if(_this.state.showAdvance)
    _this.setState({showAdvance:false})
    else if(_this.state.showDetail==4)
    {
      _this.setState({ showDetail2:0,showDetail:3 });
    }
    else
    if (_this.state.showDetail) {
      _this.setState({ showDetail:0 });
    }

    else {

      if(_this.props.onClose!=null)
      {
        _this.props.onClose();
      }
      else {
        if(_this.props.g_practice||!_this.state.showAdvance)
        _this.props.history.push("/");
        else
        _this.setState({showAdvance:false})
      }
    }
  }
  selectFormula(showType,type,sType=0){

    let formular = _.cloneDeep(defaultSetting);
    formular.displaySetting = 1;
    formular.isAdvance = 1;
    if(showType == 1)
    {
      if(type==1){
        formular.type=['image'];
        formular.showType=1;
        formular.showTypeImage='assets/web/icon_finger_r.png';
        formular.group='[BS]'+'Finger';
      }
      else if(type==2)
      {
        formular.digits = 2;
        formular.roundNumber = 1;
        formular.type=['image'];
        formular.showType=1;
        formular.showTypeImage='assets/web/icon_finger_l.png';
        formular.group='[BS]'+'Finger';
      }
      else if(type==3)
      {
        formular.digits = 2;
        formular.roundNumber = 0;
        formular.type=['image'];
        formular.showType=1;
        formular.showTypeImage='assets/web/icon_finger_both.png';
        formular.group='[BS]'+'Finger';
      }
      else if(type==4)
      {
        formular.digits = 2;
        formular.minDigits = 1;
        formular.maxDigits = 2;
        formular.roundNumber = 0;
        formular.type=['LB_0'];
        formular.showType=1;
        formular.showTypeImage='assets/web/icon_basic_plus.png';
        formular.group='[BS]'+'Basic';
      }
    }
    if(showType == 2)
    {
      if(type==1){
        formular.digits = 2;
        formular.roundNumber = 0;
        formular.type=['image'];
        formular.showType=2;
        formular.showTypeText='Flashcard';
        formular.group='[FG]'+'Finger';
      }
      else if(type==2){
        formular.digits = 2;
        formular.minDigits = 1;
        formular.maxDigits = 2;
        formular.roundNumber = 0;
        formular.type=['LB_0'];
        formular.showType=2;
        formular.showTypeText='Basic';
        formular.group='[FG]'+'Basic';
      }
      else if(type==3){
        formular.digits = 2;
        formular.minDigits = 1;
        formular.maxDigits = 2;
        formular.roundNumber = 0;
        formular.type=['LB_1','LB_2','LB_3','LB_4'];
        formular.showType=2;
        formular.showTypeText='Little Buddy +';
        formular.group='[FG]'+'LB+';
      }
      else if(type==4){
        formular.digits = 2;
        formular.minDigits = 1;
        formular.maxDigits = 2;
        formular.roundNumber = 0;
        formular.type=['LB_-1','LB_-2','LB_-3','LB_-4'];
        formular.showType=2;
        formular.showTypeText='Little Buddy -';
        formular.group='[FG]'+'LB-';
      }
      else if(type==5){
        formular.digits = 2;
        formular.minDigits = 1;
        formular.maxDigits = 2;
        formular.roundNumber = 0;
        formular.type=['BB_9.1','BB_8.1','BB_7.1','BB_6.1','BB_5.1','BB_4.1','BB_3.1','BB_2.1','BB_1.1','L&B_9.2','L&B_8.2','L&B_7.2','L&B_6.2'];
        formular.showType=2;
        formular.showTypeText='Big Buddy +';
        formular.group='[FG]'+'BB+';
      }
      else if(type==6){
        formular.digits = 2;
        formular.minDigits = 1;
        formular.maxDigits = 2;
        formular.roundNumber = 0;
        formular.type=['BB_-9.1','BB_-8.1','BB_-7.1','BB_-6.1','BB_-5.1','BB_-4.1','BB_-3.1','BB_-2.1','BB_-1.1','L&B_-9.2','L&B_-8.2','L&B_-7.2','L&B_-6.2'];
        formular.showType=2;
        formular.showTypeText='Big Buddy -';
        formular.group='[FG]'+'BB-';
      }
      else if(type==7){
        formular.digits = 2;
        formular.minDigits = 1;
        formular.maxDigits = 2;
        formular.roundNumber = 0;
        formular.type=['LB_1','LB_2','LB_3','LB_4','LB_-1','LB_-2','LB_-3','LB_-4','BB_9.1','BB_8.1','BB_7.1','BB_6.1','BB_5.1','BB_4.1','BB_3.1','BB_2.1','BB_1.1','L&B_9.2','L&B_8.2','L&B_7.2','L&B_6.2',
        'BB_-9.1','BB_-8.1','BB_-7.1','BB_-6.1','BB_-5.1','BB_-4.1','BB_-3.1','BB_-2.1','BB_-1.1','L&B_-9.2','L&B_-8.2','L&B_-7.2','L&B_-6.2'];
        formular.showType=2;
        formular.showTypeText='+/-';
        formular.group='[FG]'+'+/-';
      }
    }
    if(showType == 3)
    {
      if(sType==1)
      {
        if(type==1){
          formular.digits = 3;
          formular.roundNumber = 0;
          formular.type=['soroban'];
          formular.minDigits = 1;
          formular.maxDigits = 7;
          formular.roundNumber = 0;
          formular.showType=3;
          formular.isReversed = 1;
          formular.showTypeText='Flashcard';
          formular.group='[SP1]'+'Soroban';
        }
        else if(type==2){
          formular.digits = 2;
          formular.minDigits = 1;
          formular.maxDigits = 2;
          formular.roundNumber = 0;
          formular.type=['LB_0'];
          formular.showType=3;
          formular.isReversed = 1;
          formular.showTypeText='Basic';
          formular.group='[SP1]'+'Basic';
        }
        else if(type==3){
          formular.digits = 2;
          formular.minDigits = 1;
          formular.maxDigits = 2;
          formular.roundNumber = 0;
          formular.type=['LB_1','LB_2','LB_3','LB_4'];
          formular.showType=3;
          formular.isReversed = 1;
          formular.showTypeText='Little Buddy +';
          formular.group='[SP1]'+'LB+';
        }
        else if(type==4){
          formular.digits = 2;
          formular.minDigits = 1;
          formular.maxDigits = 2;
          formular.roundNumber = 0;
          formular.type=['LB_-1','LB_-2','LB_-3','LB_-4'];
          formular.showType=3;
          formular.isReversed = 1;
          formular.showTypeText='Little Buddy -';
          formular.group='[SP1]'+'LB-';
        }
        else if(type==5){
          formular.digits = 2;
          formular.minDigits = 1;
          formular.maxDigits = 2;
          formular.roundNumber = 0;
          formular.type=['BB_9.1','BB_8.1','BB_7.1','BB_6.1','BB_5.1','BB_4.1','BB_3.1','BB_2.1','BB_1.1'];
          formular.showType=3;
          formular.isReversed = 1;
          formular.showTypeText='Big Buddy +';
          formular.group='[SP1]'+'BB+';
        }
        else if(type==6){
          formular.digits = 2;
          formular.minDigits = 1;
          formular.maxDigits = 2;
          formular.roundNumber = 0;
          formular.type=['BB_-9.1','BB_-8.1','BB_-7.1','BB_-6.1','BB_-5.1','BB_-4.1','BB_-3.1','BB_-2.1','BB_-1.1'];
          formular.showType=3;
          formular.isReversed = 1;
          formular.showTypeText='Big Buddy -';
          formular.group='[SP1]'+'BB-';
        }
        else if(type==7){
          formular.digits = 1;
          formular.minDigits = 1;
          formular.maxDigits = 2;
          formular.roundNumber = 0;
          formular.type=['LB_1','LB_2','LB_3','LB_4','LB_-1','LB_-2','LB_-3','LB_-4','BB_9.1','BB_8.1','BB_7.1','BB_6.1','BB_5.1','BB_4.1','BB_3.1','BB_2.1','BB_1.1','BB_-9.1','BB_-8.1','BB_-7.1','BB_-6.1','BB_-5.1','BB_-4.1','BB_-3.1','BB_-2.1','BB_-1.1'];
          formular.showType=3;
          formular.isReversed = 1;
          formular.showTypeText='+/-';
          formular.group='[SP1]'+'+/-';
        }
      }
      if(sType==2)
      {
        if(type==1)
        {
          formular.digits = 2;
          formular.minDigits = 1;
          formular.maxDigits = 2;
          formular.roundNumber = 0;
          formular.isReversed = 1;
          formular.largerThan = 1;
          formular.type=['LB_1','LB_2','LB_3','LB_4','LB_-1','LB_-2','LB_-3','LB_-4','BB_9.1','BB_8.1','BB_7.1','BB_6.1','BB_5.1','BB_4.1','BB_3.1','BB_2.1','BB_1.1','BB_-9.1','BB_-8.1','BB_-7.1','BB_-6.1','BB_-5.1','BB_-4.1','BB_-3.1','BB_-2.1','BB_-1.1'];
          formular.showType=3;
          formular.showTypeText='Super 2: +/-';
          formular.showTypeImage = 'assets/web/icon_super_plus.png';
          formular.group='[SP2]'+'+/-';
        }
        if(type==2)
        {
          formular.digits = 3;
          formular.minDigits = 1;
          formular.maxDigits = 3;
          formular.digits1 = 2;
          formular.digits2 = 2;
          formular.roundNumber = 0;
          formular.type=['multiple'];
          formular.showType=3;
          formular.showTypeText='Super 2: X';
          formular.showTypeImage = 'assets/web/icon_super_multi.png';
          formular.group='[SP2]'+'Multi';
        }
      }
      if(sType==3)
      {
        if(type==1)
        {
          formular.digits = 3;
          formular.minDigits = 1;
          formular.maxDigits = 3;
          formular.roundNumber = 0;
          formular.largerThan = 1;
          formular.isReversed = 1;
          formular.type=['LB_1','LB_2','LB_3','LB_4','LB_-1','LB_-2','LB_-3','LB_-4','BB_9.1','BB_8.1','BB_7.1','BB_6.1','BB_5.1','BB_4.1','BB_3.1','BB_2.1','BB_1.1','BB_-9.1','BB_-8.1','BB_-7.1','BB_-6.1','BB_-5.1','BB_-4.1','BB_-3.1','BB_-2.1','BB_-1.1'];
          formular.showType=3;
          formular.showTypeText='Super 3: +/-';
          formular.showTypeImage = 'assets/web/icon_super_plus.png';
          formular.group='[SP3]'+'+/-';
        }
        if(type==2)
        {
          formular.digits = 3;
          formular.minDigits = 1;
          formular.maxDigits = 3;
          formular.digits1 = 3;
          formular.digits2 = 3;
          formular.roundNumber = 0;
          formular.type=['multiple'];
          formular.showType=3;
          formular.showTypeText='Super 3: X';
          formular.showTypeImage = 'assets/web/icon_super_multi.png';
          formular.group='[SP3]'+'Multi';
        }
      }
      if(sType==4)
      {
        if(type==1)
        {
          formular.digits = 4;
          formular.minDigits = 1;
          formular.maxDigits = 5;
          formular.roundNumber = 0;
          formular.largerThan = 1;
          formular.isReversed = 1;
          formular.type=['LB_1','LB_2','LB_3','LB_4','LB_-1','LB_-2','LB_-3','LB_-4','BB_9.1','BB_8.1','BB_7.1','BB_6.1','BB_5.1','BB_4.1','BB_3.1','BB_2.1','BB_1.1','BB_-9.1','BB_-8.1','BB_-7.1','BB_-6.1','BB_-5.1','BB_-4.1','BB_-3.1','BB_-2.1','BB_-1.1'];
          formular.showType=3;
          formular.showTypeText='Super 4: +/-';
          formular.showTypeImage = 'assets/web/icon_super_plus.png';
          formular.group='[SP4]'+'+/-';
        }
        if(type==2)
        {
          formular.digits = 4;
          formular.minDigits = 1;
          formular.maxDigits = 4;
          formular.digits1 = 4;
          formular.digits2 = 4;
          formular.roundNumber = 0;
          formular.type=['multiple'];
          formular.showType=3;
          formular.showTypeText='Super 4: X';
          formular.showTypeImage = 'assets/web/icon_super_multi.png';
          formular.group='[SP4]'+'Multi';
        }
        if(type==3)
        {
          formular.digits = 4;
          formular.minDigits = 1;
          formular.maxDigits = 4;
          formular.digits1 = 4;
          formular.digits2 = 4;
          formular.roundNumber = 0;
          formular.type=['divide'];
          formular.showType=3;
          formular.showTypeText='Super 4: /';
          formular.showTypeImage = 'assets/web/icon_super_divide.png';
          formular.group='[SP4]'+'Divide';
        }
      }
    }
    _this.setState({showAdvance:true,formular});
  }

getQuestionEQ(question,width)
{
  let rel = '';
  if(question.type!="image"&&question.type!="soroban")
  {

    for(let num of question.numbers)
    {
      if(question.type!='multiple'&&question.type!='divide')
      {
        if(rel=='')
        {
          rel=num;
          continue;
        }
        else {
          rel += (num>=0?' + ':' - ')+Math.abs(num);
        }
      }
      else {
        if(rel=='')
        {
          rel+=num;
        }
        else {
          rel+=""+num;
        }
      }

    }
  }
  else
  if(question.type=="soroban")
  {
    rel = "Soroban";
  }
  else {
    rel = (<div style={{display:'inline-block'}}>{question.images.map((i,index)=>{
      return (<img key={"image"+index}
  src={i}
  style={{width: STATIC.calSize(30, STATIC.DWIDTH, width), height: 'auto'}} />)
    })}

    </div>)
  }
  return rel;
}


  render() {
    const { classes,t } = this.props;
    const { wWidth, wHeight, curWeek, curDay, showResult, course,result,showAdvance,showResultDetail,title,showDetail,showDetail2,saving,saving_error } = this.state;
    let width = DWIDTH;
    if (wWidth < DWIDTH) {
      width = wWidth;
    }
    let sRate = 640 / 1010;
    if ((curWeek > -1 && curDay > -1)||showAdvance) {
      sRate = 980 / 640;
    }
    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let bRate = 391 / 271;

    let bWidth = width / 2;


    let ACCOUNT = store.getState().ACCOUNT;
    if (!ACCOUNT) {

      return (<Redirect to='/login' />);
    }
    if(showDetail==1&&!showAdvance)
    {
      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
          <TopBar width={width} />
            <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
              <div style={{ marginBottom: STATIC.calSize(curWeek > -1 && curDay > -1 ? 10 : 30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.setState({showDetail:0})}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>

                </div>

              </div>
              <Grid container alignItems="center" justify="center" >
                <Grid item  style={{ margin: STATIC.calSize(35, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(1,1)} focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth*0.7 }} color="primary" size="large" variant="contained"  >
                    <img src={"assets/web/icon_finger_r.png"} style={{ width: bWidth*0.7 }} />

                  </ButtonBase>

                </Grid>
                <Grid item  style={{ margin: STATIC.calSize(35, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(1,2)} focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth*0.7 }} color="primary" size="large" variant="contained"  >
                    <img src={"assets/web/icon_finger_l.png"} style={{ width: bWidth*0.7 }} />


                  </ButtonBase>

                </Grid>
                <Grid item  style={{ margin: STATIC.calSize(35, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(1,3)} focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth*0.7 }} color="primary" size="large" variant="contained"  >
                    <img src={"assets/web/icon_finger_both.png"} style={{ width: bWidth*0.7 }} />

                  </ButtonBase>

                </Grid>
                <Grid item  style={{ margin: STATIC.calSize(35, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(1,4)} focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth*0.7 }} color="primary" size="large" variant="contained"  >
                    <img src={"assets/web/icon_basic_plus.png"} style={{ width: bWidth*0.7 }} />

                  </ButtonBase>

                </Grid>
                </Grid>

            </div>
          </div>
          <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
            <ButtonBase

              onClick={() => this.backClick()}>
            <img
              src="assets/web/logo_trans.png"
              style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
          </ButtonBase>
          </div>
        </div>
        )
    }
    if(showDetail==2&&!showAdvance)
    {
      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
          <TopBar width={width} />
            <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
              <div style={{ display: 'flex' }}>
                <ButtonBase
                  focusRipple
                  onClick={() => this.setState({showDetail:0})}
                  style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                  <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                </ButtonBase>

              </div>
              <Grid container direction='column' alignItems="center" justify="center" >
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(2,1)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Flashcard</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(2,2)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Basic</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(2,3)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Little Buddy +</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(2,4)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Little Buddy -</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(2,5)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Big Buddy +</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(2,6)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Big Buddy -</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(2,7)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>+/-</div>
                  </ButtonBase>

                </Grid>


                </Grid>

            </div>
          </div>
          <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
            <ButtonBase

              onClick={() => this.backClick()}>
            <img
              src="assets/web/logo_trans.png"
              style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
          </ButtonBase>
          </div>
        </div>
        )
    }
    if(showDetail==3&&!showAdvance)
    {
      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
          <TopBar width={width} />
            <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
              <div style={{ display: 'flex' }}>
                <ButtonBase
                  focusRipple
                  onClick={() => this.setState({showDetail:0})}
                  style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                  <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                </ButtonBase>

              </div>
              <Grid container direction='column' alignItems="center" justify="center" >
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.setState({showDetail:4,showDetail2:1})} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Super 1</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.setState({showDetail:5,showDetail2:2})} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Super 2</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.setState({showDetail:5,showDetail2:3})} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Super 3</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.setState({showDetail:5,showDetail2:4})} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Super 4</div>
                  </ButtonBase>

                </Grid>

                </Grid>

            </div>
          </div>
          <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
            <ButtonBase

              onClick={() => this.backClick()}>
            <img
              src="assets/web/logo_trans.png"
              style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
          </ButtonBase>
          </div>
        </div>
        )
    }
    if(showDetail==4&&!showAdvance)
    {
      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
          <TopBar width={width} />
            <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
              <div style={{ display: 'flex' }}>
                <ButtonBase
                  focusRipple
                  onClick={() => this.setState({showDetail:3})}
                  style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                  <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                </ButtonBase>

              </div>
              <Grid container direction='column' alignItems="center" justify="center" >
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,1,1)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Flashcard</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,2,1)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Basic</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,3,1)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Little Buddy +</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,4,1)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Little Buddy -</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,5,1)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Big Buddy +</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,6,1)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>Big Buddy -</div>
                  </ButtonBase>

                </Grid>
                <Grid item  style={{ marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,7,1)} focusRipple style={{ color: "rgb(5, 63, 34)",position:'relative',boxShadow:'-'+STATIC.calSize(3, STATIC.DWIDTH, width)+'px '+STATIC.calSize(3, STATIC.DWIDTH, width)+'px', display: 'flex',borderRadius:STATIC.calSize(10, STATIC.DWIDTH, width), width: width*0.8,height:STATIC.calSize(60, STATIC.DWIDTH, width) ,backgroundColor:'white', }} color="primary" size="large" variant="contained"  >

                    <div style={{fontSize:fTitle}}>+/-</div>
                  </ButtonBase>

                </Grid>


                </Grid>

            </div>
          </div>
          <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
            <ButtonBase

              onClick={() => this.backClick()}>
            <img
              src="assets/web/logo_trans.png"
              style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
          </ButtonBase>
          </div>
        </div>
        )
    }
    if(showDetail==5&&!showAdvance)
    {
      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
          <TopBar width={width} />
            <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
              <div style={{ display: 'flex' }}>
                <ButtonBase
                  focusRipple
                  onClick={() => this.setState({showDetail:3})}
                  style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                  <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                </ButtonBase>

              </div>
              <Grid container alignItems="center" justify="center" >
                <Grid item  style={{ margin: STATIC.calSize(35, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,1,showDetail2)}  focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth*0.5 }} color="primary" size="large" variant="contained"  >
                    <img src={"assets/web/icon_super_plus.png"} style={{ width: bWidth*0.5 }} />

                  </ButtonBase>

                </Grid>
                {showDetail2>=2?<Grid item  style={{ margin: STATIC.calSize(35, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,2,showDetail2)} focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth*0.5 }} color="primary" size="large" variant="contained"  >
                    <img src={"assets/web/icon_super_multi.png"} style={{ width: bWidth*0.5 }} />


                  </ButtonBase>

                </Grid>:false}
                {showDetail2>3?<Grid item  style={{ margin: STATIC.calSize(35, STATIC.DWIDTH, width) }}>
                  <ButtonBase onClick={()=>this.selectFormula(3,3,showDetail2)} focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth*0.5 }} color="primary" size="large" variant="contained"  >
                    <img src={"assets/web/icon_super_divide.png"} style={{ width: bWidth*0.5 }} />

                  </ButtonBase>

                </Grid>:false}

                </Grid>

            </div>
          </div>
          <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
            <ButtonBase

              onClick={() => this.backClick()}>
            <img
              src="assets/web/logo_trans.png"
              style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
          </ButtonBase>
          </div>
        </div>
        )
    }

    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
<TopBar width={width} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />
              {showAdvance?<div style={{ marginBottom: STATIC.calSize(curWeek > -1 && curDay > -1 ? 10 : 30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{title}</div>
                </div>
                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
              </div>:false}
              {!showAdvance?<div style={{ marginBottom: STATIC.calSize(curWeek > -1 && curDay > -1 ? 10 : 30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{t('common.advance')}</div>
                </div>
                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />
              </div>:false}
              {!showAdvance?<div style={{width:STATIC.calSize(600, STATIC.DWIDTH, width),height:STATIC.calSize(750, STATIC.DWIDTH, width)}}>
                <Grid container direction="column" alignItems="center" justify="center" >
                  <Grid item xs style={{ marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.setState({showDetail:1})} focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth }} color="primary" size="large" variant="contained"  >
                      <img src={"assets/web/icon_btn_basic.png"} style={{ width: bWidth }} />

                    </ButtonBase>

                  </Grid>
                  <Grid item xs style={{ marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.setState({showDetail:2})}  focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth }} color="primary" size="large" variant="contained"  >
                      <img src={"assets/web/icon_btn_finger.png"} style={{ width: bWidth }} />


                    </ButtonBase>

                  </Grid>


                  <Grid item xs style={{ marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }}>
                    <ButtonBase onClick={()=>this.setState({showDetail:3})}  focusRipple style={{ color: "white",position:'relative', display: 'inline-block', width: bWidth }} color="primary" size="large" variant="contained"  >
                      <img src={"assets/web/icon_btn_super.png"} style={{ width: bWidth }} />

                    </ButtonBase>

                  </Grid>


                </Grid>
              </div>:false}

              {showAdvance ? <LessonComp
                {...this.state.formular}
                showAdvance={this.props.g_practice?false:true}
                updateTitle={(title)=>this.setState({title})}
                onLessonEnd={this.onAdvanceEnd}
              /> : false}
              <Link to="/" style={{ width: '100%' }}>
                <img
                  src="assets/web/logo_green.png"
                  style={{ maxWidth: 296, height: 'auto', marginTop: STATIC.calSize(20, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(20, STATIC.DWIDTH, width), width: STATIC.calSize(189, STATIC.DWIDTH, width) }} />
              </Link>

            </div>




            <Modal styles={{ modal: { minWidth: width * 0.8, background: 'white',textAlign:'center' } }} open={showResultDetail&&!saving&&!saving_error} onClose={() => this.setState({ showResultDetail: false })} center>
              <div>
                    <Grid container direction="row" style={{marginTop:STATIC.calSize(40, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}} >
                        <Grid item xs={1} >
                          <div style={{fontSize: fSmall}}>{t('common.id')}</div>
                        </Grid>
                        <Grid item xs={5} >
                          <div style={{fontSize: fSmall,textAlign:'left'}}>{t('common.question')}</div>

                        </Grid>
                        <Grid item xs={2} >
                          <div style={{fontSize: fSmall}}>{t('common.input')}</div>

                        </Grid>
                        <Grid item xs={2} >
                          <div style={{fontSize: fSmall}}>{t('common.correct')}</div>

                        </Grid>
                        <Grid item xs={2} >
                          <div style={{fontSize: fSmall}}>{t('common.result')}</div>
                        </Grid>
                    </Grid>
                    <Divider />
                    {result&&result.questions?result.questions.map((q,index)=>{
                      return (<Grid key={index} container direction="row" style={{marginTop:STATIC.calSize(10, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width)}} >
                          <Grid item xs={1} >
                            <div style={{fontSize: fSmall}}>{index+1}</div>
                          </Grid>
                          <Grid item xs={5} >
                            <div style={{fontSize: fSmall,textAlign:'left'}}>{this.getQuestionEQ(q,width)} =</div>

                          </Grid>
                          <Grid item xs={2} >
                            <div style={{fontSize: fSmall}}>{q.answer}</div>

                          </Grid>
                          <Grid item xs={2} >
                            <div style={{fontSize: fSmall}}>{q.result}</div>

                          </Grid>
                          <Grid item xs={2} >
                            <div style={{fontSize: fNormal,color:q.status==1?'green':"red"}}>{q.status==1?<CheckIcon style={{fontSize:fNormal}}/>:"X"}</div>
                          </Grid>
                      </Grid>)
                    }):false}
                    <Divider />
                    <div style={{textAlign: 'right', fontSize: fSmall, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{t('common.total')}: {result.countCorrect}/{result.qlength}<br />({result.percent}%)</div>
                  <div style={{textAlign: 'left', marginTop: STATIC.calSize(40, STATIC.DWIDTH, width)}}>
                    <img
                    src="assets/web/logo_green.png"
                    style={{width: width*0.2, maxWidth: 296, height: 'auto'}} />
                    </div>

              </div>
            </Modal>
            <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={saving&&!saving_error} onClose={() => this.setState({ })} center>
              <div style={{ width: width * 0.8, position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                <div style={{textAlign:'center'}}>
                <CircularProgress style={{color:'white'}}/>
                <div style={{fontSize:fNormal}}>{t('common.save_result')}</div>
                </div>
              </div>
            </Modal>
            <Modal styles={{overlay:{padding:0}, modal: { background: 'none',textAlign:'center' } }} onClose={()=>{}} showCloseIcon={false} focusTrapped={false} open={saving_error} center>
              <div style={{ width: "100%", backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH), padding: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) }}>
                <div style={{ display: 'flex',flexDirection:'column' }}>

                    <div style={{textAlign: 'center', fontSize: fNormal, marginTop: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH)}}>{t('common.saving_error')}</div>
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center', marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                      <Button onClick={()=>this.setState({saving:false,saving_error:false})} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                        {t('common.close')}
                      </Button>
                      <div style={{flexGrow:1}}></div>
                      <Button onClick={()=>this.postResultToServer(this.state.nResult)} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                        {t('common.saving_retry')}
                      </Button>

                    </div>
                    </div>
                  </div>
                </Modal>

          </div>


        </div>

      </div>
    );
  }
}


Advance.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(Advance));
